import { Injectable, Inject, Optional } from '@angular/core';
import { BaseEntityAttribute } from './base-entity-attribute';
// import { BaseEntityAttribute } from './base-entity-attribute.service';

@Injectable({
  providedIn: 'root'
})
export class BuildingAttribute extends BaseEntityAttribute {
  constructor(@Optional() @Inject('mapEntityId') mapEntityId?: string) {
    // Adjust parameters passed to BaseEntityAttribute as needed
    super(undefined, mapEntityId, false, false, undefined);
  }

  setMapEntityId(id: string): void {
    super.getMapEntityId(); // Access through base class method
  }

  override getDirective(): string {
    return `<buildingattributevisualizer [mapentityId]="'${this.getMapEntityId()}'"></buildingattributevisualizer>`;
  }
}
